import { useEffect, useState } from 'react';

export const useParams = () => {
  const [query, setQuery] = useState<any>({});
  const params = new URLSearchParams(JSON.parse(JSON.stringify(query)));
  const paramsString = params.toString();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const query = Object.fromEntries(searchParams);
    setQuery(query);
  }, []);

  return { query, params, paramsString };
};
